<!--实验室成员列表侧边栏-->
<template>

  <div class="member-aside-box">

    <div>
      <div class="member-aside-title" align="center">实验室成员列表</div>
      <div class="member-aside-list-item" v-for="(item,index) in memberlist" @click="goNext(item.id)">
        <div class="member-aside-list-item-text">
          {{item.name}}
        </div>
      </div>
    </div>

  </div>


</template>

<script>
  export default {
    data() {
      return {
        memberlist: '',
      };
    },

    components: {},

    mounted() {
      this.getMemberList();
    },

    methods: {
      // 切换
      goNext(id) {
        this.$router.push({path:'/memberdetail',query: {id:id}})
      },

      // 获取成员列表
      getMemberList() {
        this.instance.get('/api/memberlist').then(res => {
          if (res.status == 200) {
            this.memberlist = res.data.memberlist;
          }
        })
      },
    },

  }
</script>
<style scoped>
  .member-aside-box {
    position: relative;
    width: 100%;
    height: 100%;
    background: hsla(0, 0%, 100%, .2);
    border: 0.1vw solid rgb(60, 74, 93, .2);
    box-shadow: 0 0.3vw 0.4vw rgba(0, 0, 0, .12), 0 0 0.6vw rgba(0, 0, 0, .04);
  }



  .member-aside-title {
    height: 4vw;
    font-size: 1.2vw;
    font-weight: bold;
    color: #3C4A5D;
    /* text-align: center; */
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 0.15vw solid rgba(60, 74, 93, 0.4);
  }

  .member-aside-list-item {
    height: 4vw;
    width: 100%;
    font-size: 0.9vw;
    font-weight: bold;
    color: #3C4A5D;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor:pointer;
    /* border: 1px solid blue; */
  }

  .member-aside-list-item-text {
    text-align: center;
    width: 94%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .member-aside-list-item-text:hover {
    position: absolute;
    width: 100%;
    white-space: normal;
    /* text-overflow:inherit;
      overflow: visible;
      white-space: pre-line; */
    /*合并空白符序列，但是保留换行符。*/
  }

  .member-aside-list-item:hover {
    background-color: rgba(254, 232, 166, 0.4);
  }



</style>



// WEBPACK FOOTER //
// src/components/MemberAside.vue